import { SET_CUSTOMERS_DATA_LOADING, SET_CUSTOMERS } from "./types";
import store from "../../../../store";
import Axios from "../../../../common/util/Axios";

export const getCustomers = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_CUSTOMERS_DATA_LOADING });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    const queryParams = {
      ...params,
      companyId,
      branchId,
    };

    console.log('params : ', params);
    const res = await Axios.get(`/api/dashboard/customers/find-customers-with-keyword`, {
      params: queryParams,
    });

    console.log('res : ', res.data);
    dispatch({
      type: SET_CUSTOMERS,
      payload: {
        data: res.data.data,
        pagination: res.data.pagination,
      },
    });
  } catch (err) {
    dispatch({
      type: SET_CUSTOMERS,
      payload: [],
    });
  }
};